<template>
	<div>
		<div v-for="(bundle, i) in unitData.bundle_list" :key="i" class="m-product">
			<div class="m-product-list flex">
				<ul class="flex">
					<template v-for="(item, j) in bundle.product_list">
						<div v-if="j > 0" :key="`plus${j}`" class="plus flex-center">
							<span>+</span>
						</div>
						<li :key="j">
							<sub-image class="image" :src="item.productImgUrl"></sub-image>
							<p class="name ellipsis-2">{{item.productName}}</p>
							<p>￥{{item.productPrice}}</p>
						</li>
					</template>
				</ul>
			</div>
			<div class="bottom flex-row flex-between-center">
				<span class="bottom-save">可节省￥{{bundle.reduce_money}}</span>
				<div class="bottom-price flex-row flex-grow flex-end-center">
					<div class="flex-row flex-baseline">
						<span>组合价:￥</span>
						<span>{{bundle.bundle_price}}</span>
					</div>
				</div>
				<div class="bottom-button flex-center">去抢购</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product {
		border-radius: 10px;
		margin: 0 12px;
		overflow: hidden;
		background: #fff;
		
		&:nth-child(n+2) {
			margin-top: 12px;
		}
		
		&-list {
			height: 206px;
			padding: 0 10px;
			border-radius: 6px;
			overflow: hidden;
			background: #fff;
			
			ul {
				float: left;
				
				.plus {
					align-self: flex-start;
					width: 30px;
					margin-top: 10px;
					line-height: 120px;
					font-size: 18px;
					color: #999;
				}
				
				li {
					width: 120px;
					padding-top: 10px;
					
					.image {
						height: 120px;
					}
					
					.name {
						height: 32px;
						margin: 5px 0;
						line-height: 16px;
						font-size: 12px;
						font-weight: normal;
						color: #666;
					}
					
					p {
						font-size: 16px;
					}
				}
			}
		}
	}
	
	.bottom {
		gap: 10px;
		height: 54px;
		padding: 0 13px;
		background: #F5F5F5;
		
		&-save {
			font-size: 12px;
			color: #666;
		}
		
		&-price {
			font-size: 13px;
			color: #FF1200;
			
			text:nth-child(2) {
				font-size: 24px;
			}
		}
		
		&-button {
			width: 86px;
			height: 36px;
			border-radius: 18px;
			box-shadow: 0 2px 5px 0 rgba(212,15,0,.2);
			font-size: 16px;
			color: #fff;
			background: #FF1200;
		}
	}
</style>
